module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "ql-new-layer-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.addLayer.apply(null, arguments)
      }
    }
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Add a New Layer")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-container-invalid': _vm.isNewLayerTitleInvalid
    },
    staticStyle: {
      "margin": "0px 0 0px !important"
    }
  }, [_c('label', {
    attrs: {
      "for": "layer-title"
    }
  }, [_vm._v("Layer Title")]), _vm._v(" "), _c('md-input', {
    class: {
      'invalid-input': _vm.isNewLayerTitleInvalid
    },
    attrs: {
      "id": "layer-title",
      "required": ""
    },
    on: {
      "input": _vm.validateLayerTitle
    },
    model: {
      value: (_vm.newLayerTitle),
      callback: function($$v) {
        _vm.newLayerTitle = $$v
      },
      expression: "newLayerTitle"
    }
  })], 1), _vm._v(" "), (_vm.isNewLayerTitleInvalid) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("Enter the Layer title.")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "property-box",
    staticStyle: {
      "padding": "0 0px 0px !important"
    }
  }, [_c('div', {
    staticClass: "property-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Color")]), _vm._v(" "), _c('div', {
    staticClass: "current-color-box",
    style: ({
      backgroundColor: this.color
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "property-content note_color"
  }, [
    [_c('div', {
      staticClass: "color-swatches"
    }, [_c('div', {
      staticClass: "color-box color-box-black",
      on: {
        "click": function($event) {
          return _vm.pickSpecificColor('#000000')
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "color-box color-box-red",
      on: {
        "click": function($event) {
          return _vm.pickSpecificColor('#ff0000')
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "color-box color-box-green",
      on: {
        "click": function($event) {
          return _vm.pickSpecificColor('#00ff00')
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "color-box color-box-blue",
      on: {
        "click": function($event) {
          return _vm.pickSpecificColor('#0000ff')
        }
      }
    })]), _vm._v(" "), _c('color-picker', {
      on: {
        "input": _vm.pickColor
      },
      model: {
        value: (_vm.color),
        callback: function($$v) {
          _vm.color = $$v
        },
        expression: "color"
      }
    })]
  ], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.addLayer
    }
  }, [_vm._v("Add Layer")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2821b674","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layers/layer-new.vue
// module id = 1216
// module chunks = 21